import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { CheckCircle2, AlertCircle, X, RotateCw } from "lucide-react";
import "./UploadProgressList.css";

const STATUS_LABEL = {
  preparing: "Preparing…",
  waiting: "Waiting…",
  uploading: "Uploading…",
  processing: "Processing…",
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
};

/**
 * One row per in-flight file. items: [{id, name, progress, status, error}]
 */
const UploadProgressList = ({ items, onCancel, onRetry, onDismiss, className = "" }) => {
  if (!items || !items.length) return null;
  return (
    <div className={`mentor-upload-progress ${className}`.trim()} role="status" aria-live="polite">
      {items.map((item) => (
        <div key={item.id} className="mentor-upload-progress__row">
          <div className="mentor-upload-progress__info">
            <span className="mentor-upload-progress__name" title={item.name}>{item.name}</span>
            <span className="mentor-upload-progress__status">
              {item.status === "completed" ? <CheckCircle2 size={13} /> : null}
              {item.status === "failed" ? <AlertCircle size={13} /> : null}
              {STATUS_LABEL[item.status] || item.status}
              {["preparing", "waiting", "uploading", "processing"].includes(item.status)
                ? ` ${Math.round(item.progress || 0)}%`
                : ""}
              {item.status === "failed" && item.error ? `: ${item.error}` : ""}
            </span>
          </div>
          {["preparing", "uploading", "waiting", "processing"].includes(item.status) ? (
            <ProgressBar
              completed={item.progress || 0}
              bgColor="var(--sa-accent)"
              baseBgColor="var(--sa-track-bg)"
              height="6px"
              isLabelVisible={false}
              className="mentor-upload-progress__bar"
            />
          ) : null}
          {item.detail ? <div className="mentor-upload-progress__detail">{item.detail}</div> : null}
          <div className="mentor-upload-progress__actions">
            {item.status === "failed" && onRetry ? (
              <button type="button" className="mentor-icon-btn" onClick={() => onRetry(item.id)} aria-label={`Retry ${item.name}`}>
                <RotateCw size={13} />
              </button>
            ) : null}
            {(item.status === "uploading" || item.status === "waiting") && onCancel ? (
              <button type="button" className="mentor-icon-btn" onClick={() => onCancel(item.id)} aria-label={`Cancel ${item.name}`}>
                <X size={13} />
              </button>
            ) : null}
            {(item.status === "completed" || item.status === "cancelled" || item.status === "failed") && onDismiss ? (
              <button type="button" className="mentor-icon-btn" onClick={() => onDismiss(item.id)} aria-label={`Dismiss ${item.name}`}>
                <X size={13} />
              </button>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UploadProgressList;
